import { EGS_CATEGORY } from '../../checklistCategories';
import { formatCapacityWithBreakdown, formatMoney, formatOptionalNumber } from '../../shared/format';
import type { ApprovalQueueItem } from '../../types';

import type { EgsAgeCoverageRowView, EgsCapacityRowView, EgsMarginRowView } from './types';

export function buildMarginQueueItem(row: EgsMarginRowView): ApprovalQueueItem {
  return {
    categoryId: EGS_CATEGORY.id,
    categoryLabel: EGS_CATEGORY.label,
    description: `${row.name} has a ${row.marginBand ? `${row.marginBand} ` : ''}margin check and needs review.`,
    details: [
      { label: 'Opportunity', value: row.opportunityName || 'Opportunity not mapped' },
      { label: 'Extra guest type', value: row.extraGuestType || 'N/A' },
      { label: 'Age range', value: row.ageRange || 'N/A' },
      { label: 'Cost price', value: formatMoney(row.costPrice, row.currencyCode) },
      { label: 'Sell price', value: formatMoney(row.sellPrice, row.currencyCode) },
      { label: 'Margin', value: typeof row.margin === 'number' ? `${row.margin.toFixed(1)}%` : 'N/A' },
      { label: 'Bedding type', value: row.beddingType || 'N/A' },
      { label: 'Inclusions', value: row.inclusions || 'N/A' },
      { label: 'Collected by', value: row.collectedBy || 'N/A' },
    ],
    id: row.id,
    title: row.name,
  };
}

export function buildCapacityQueueItem(row: EgsCapacityRowView): ApprovalQueueItem {
  return {
    categoryId: EGS_CATEGORY.id,
    categoryLabel: EGS_CATEGORY.label,
    description: `${row.name} capacity requires approval.`,
    details: [
      { label: 'Room asset', value: row.roomName },
      { label: 'Included capacity', value: formatCapacityWithBreakdown(row.includedCapacity, row.includedOccupancy) },
      { label: 'Max room capacity', value: formatCapacityWithBreakdown(row.maxRoomCapacity, row.maxOccupancy) },
      { label: 'EGS contracted for', value: formatOptionalNumber(row.egsCapacity) },
    ],
    id: row.id,
    title: row.name,
  };
}

export function buildAgeCoverageQueueItem(row: EgsAgeCoverageRowView): ApprovalQueueItem {
  return {
    categoryId: EGS_CATEGORY.id,
    categoryLabel: EGS_CATEGORY.label,
    description: row.summary,
    details: row.details,
    id: row.id,
    title: row.name,
  };
}

export function getAgeCoverageSearchText(row: EgsAgeCoverageRowView) {
  return [row.name, row.summary, ...row.details.map((detail) => detail.label), row.statusLabel].join(' ');
}

export function getMarginSearchText(row: EgsMarginRowView) {
  return [
    row.name,
    row.opportunityName,
    row.extraGuestType,
    row.ageRange,
    row.currencyCode,
    row.beddingType,
    row.inclusions,
    row.collectedBy,
    row.statusLabel,
  ]
    .filter(Boolean)
    .join(' ');
}

export function getCapacitySearchText(row: EgsCapacityRowView) {
  return [row.name, row.roomName, row.statusLabel].filter(Boolean).join(' ');
}
